import { gql } from 'apollo-angular';

export const newsFragment = gql`
fragment news on News {
  _id
  title
  image
  publishDate
  updatedAt
  slug
  views
  allowSeoIndex
  fieldsOfRelevance
  metaTitle
  author(lang: $lang) {
    _id
    username
    slug
    roles
    profile {
      _id
      lang
      fullName
      picture
    }
  }
  newsStatus
  newsletterStatus
  company(lang: $lang) {
    _id
    fullName
    logo
    slug
    primaryPath
    accountType
  }
  categories(lang: $lang) {
    path
    name
  }
  tags(lang: $lang) {
    tag
    slug
    newsCount
  }
  timeToPublish
  deleted
  isAccessibleForFree
}
`;

